function NewOpportunity() {

  return (
    <div>
      <p>Use oportunidades para acompanhar as suas vendas.</p>
    </div>
  );
}
export default NewOpportunity;
